function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M21 15l-2-9h-5v9l1 1v4.003c0 .544.444.997.99.997h4.02c.539 0 .99-.444.99-.99V15zM9 16v4.003c0 .55-.451.997-.99.997H3.99a.996.996 0 01-.99-.99V15l2-9h5v9l-1 1zM6 3h4v2H6V3zm8 0h4v2h-4V3zm-3 3h2v8h-2V6z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgLocationViewpoint = function SvgLocationViewpoint(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgLocationViewpoint;